import AppAction from "@my-dld/actions";
import { Action } from "redux";
import { BaseEjariContract, EjariProperty } from "@eres/ejari-api/Entity";
import { Contract, ContractFinance, ContractPayment, ContractTerm, MoveOut } from "@eres/ejari-api/Entity/contract";
import { EjariUserType } from "./EjariData";
import { TenancyContactAction } from "../constants";
import { Tenant } from "@eres/ejari-api/Entity/tenant";

export interface EjariContractDataState {
	AllowedCoTenants?: number;
	originalContract?: Contract;
	property?: EjariProperty;
	activeUserId?: number;
	isRefreshing?: boolean;
	userType: EjariUserType;
	contract?: Contract;
	miniContract?: BaseEjariContract;
	contractNumber?: string;
	isCommercial?: boolean;
	action?: TenancyContactAction;
	OrgTenant?: Tenant;
	tenant?: Tenant;
	OrgFinance?: ContractFinance;
	finance?: ContractFinance;
	Payments?: ContractPayment[];
	NoOfPayments?: number;
	SecurityDeposit?: string;
	AdditionalTerms?: ContractTerm[];
	tenantApproval?: boolean;
	newContract?: Contract;
	actionDone: boolean;
	feePayMode?: "tenant" | "paid";
	hazardIds?: number[];
	moveOut?: MoveOut;
	TotalCoTenants?: number;
}


export const defaultState: EjariContractDataState = {
	userType: "owner",
	actionDone: false,
};

export enum EjariContractDataAction {
	EJARI_CONTRACT_CLEAR_DATA = "EJARI_CONTRACT_CLEAR_DATA",
	EJARI_CONTRACT_UPDATE_PROPERTY = "EJARI_CONTRACT_UPDATE_PROPERTY",
	EJARI_CONTRACT_UPDATE_STATE = "EJARI_CONTRACT_UPDATE_STATE",
}

export type EjariContractAction =
	Action<AppAction.USER_LOGGED_OUT> |
	Action<EjariContractDataAction.EJARI_CONTRACT_CLEAR_DATA> |
	Action<EjariContractDataAction.EJARI_CONTRACT_UPDATE_PROPERTY> & { payload?: EjariProperty } |
	Action<EjariContractDataAction.EJARI_CONTRACT_UPDATE_STATE> & { payload?: Partial<EjariContractDataState> };

export function EjariContractDataReducer( state = defaultState, action: EjariContractAction ) {
	switch ( action.type ) {
		case EjariContractDataAction.EJARI_CONTRACT_CLEAR_DATA:
			return {
				...defaultState
			};
		case EjariContractDataAction.EJARI_CONTRACT_UPDATE_PROPERTY:
			return {
				...state,
				property: action.payload,
			};
		case EjariContractDataAction.EJARI_CONTRACT_UPDATE_STATE:
			return {
				...state,
				...action.payload,
			};

		case AppAction.USER_LOGGED_OUT:
			return { ...defaultState };
		default:
			return state;
	}
}
